export enum NotificationType {
  CASE_UPDATES = 1,
  GENERAL_INFO = 2,
  CASE_MANAGEMENT = 3,
  ACTION_HISTORY = 4,
}

export interface GetNotificationHistoryQueryPayload {
  notificationType: NotificationType
  pageNumber: number
  pageSize: number
  /**
   * Fetch data only from dates after the specified date (default: one year ago)
   */
  startDate?: string
}

export interface GetNotificationHistoryQueryResponse {
  currentPage: number
  /**
   * true: there are updates within 24 hours
   */
  isUpdated: boolean
  pageSize: number
  result: NotificationItem[]
  totalCount: number
  totalPages: number
}

export interface NotificationItem {
  createdAt: string
  link: string
  message: string
  messageType: NotificationMessageType
}

export type NotificationMessageType =
  | 'GENERAL'
  | 'CASE_STATUS'
  | 'BULLETIN'
  | 'ALERT'
  | 'INQUIRY_ELIGIBLE'
  | 'AOS_ELIGIBLE'
